import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/useIsMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faVideo, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { AuthedVideoPlayer } from "../ui/AuthedVideoPlayer";

interface FilePlaceHolderVideoProps {
    url: string | null;
    controls?: boolean;
    playing?: boolean;
    loop?: boolean;
    height?: string;
    placeholderStyles?: React.CSSProperties;
    placeholderIcon?: IconDefinition;
    placeholderText?: string;
    donwloadTitle?: string;
    onDownload?: () => void;
    onDropImage?: (file:File) => void;
}

export const FilePlaceHolderVideo = ({
    url,
    controls=true,
    playing=true,
    loop=true,
    height="520px",
    donwloadTitle,
    placeholderStyles,
    placeholderIcon,
    placeholderText,
    onDownload,
    onDropImage
}:FilePlaceHolderVideoProps) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation('generation');
    return (
        <>
            { url 
                ?   <>
                        <div className='text-center my-1 border border-secondary rounded d-block' style={{height:height, width:'auto', maxWidth:'100%'}}>
                            <AuthedVideoPlayer
                                url={url}
                                controls={controls}
                                playing={playing}
                                loop={loop}
                                height="100%"
                            />
                        </div>
                        { onDownload && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary mt-0 position-absolute top-0 end-0 m-2 border border-secondary rounded"
                                title={donwloadTitle ?? t("download.video")}
                                onClick={onDownload}
                                style={{ zIndex: 2 }}
                            >
                                <FontAwesomeIcon
                                    icon={faDownload}
                                    size="xl"
                                    className="bg-transparent me-2"
                                />
                            </button>
                            )
                        }
                    </>
                :   <div
                        className={`text-center border border-secondary border-opacity-25 rounded mt-2 d-flex flex-column align-items-center justify-content-center ${isMobile ? 'h4' : 'h3'}`}
                        style={{
                            ...placeholderStyles,
                            width: isMobile ? "180px" : "100%",
                            height: isMobile ? "180px" : "100%",
                            minHeight: isMobile ? "180px" : "250px"
                        }}
                    >
                        <p className="m-0 p-0 opacity-25">
                            <FontAwesomeIcon
                                icon={placeholderIcon ?? faVideo}
                                size={isMobile ? '1x' : "2xl"}
                                className="me-2"
                            />
                            {placeholderText ?? t('noGeneratedVideo')}
                        </p>
                    </div>
                
            }
        </>
    )
};